import { render, staticRenderFns } from "./trainee-details.vue?vue&type=template&id=12102af7&scoped=true&"
import script from "./trainee-details.vue?vue&type=script&lang=js&"
export * from "./trainee-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12102af7",
  null
  
)

export default component.exports